import type { NotificationBanner } from "@/modules/notificationBanner/api/getNotificationBanner"

export const getHiddenBannerCookieValue = (notificationBanner: NotificationBanner): string =>
  `${notificationBanner.idOld}_hidden_for_${notificationBanner.scope}`
